import React from 'react';
import { Input, Button, PaperClip, Select, Textarea } from 'components';
import { QuoteService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

interface Props extends RootState {
	onClose?: any;
	item?: any;
	services: any;
	quote_amounts: any;
	quote_questions: any;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			patient: '',
			service_id: ''
		},
		services: [],
		quote_questions: [],
		quote_amounts: []
	}

	async componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
				},
				item: this.props.item
			});
		}

		this.loadData();

		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					patient: this.props.item?.patient || '',
					service_id: this.props.item?.service_id || '',
				}
			});
		}
	}

	loadData = async () => {
		const res: any = await QuoteService.doctor.getData({
			withoutLoading: true
		});
		this.setState({
			quote_amounts: res.quote_amounts.map((item: any) => {
				item.quantity = '';
				const _item = this.props.item?.quote_detail_amounts?.find((i: any) => i.quote_amount_id == item.id);
				if (_item) {
					item.quantity = _item.quantity;
				}
				return item;
			}),
			quote_questions: res.quote_questions.map((item: any) => {
				item.description = '';
				item.quantity = '';
				item.enabled = false;
				const _item = this.props.item?.quote_detail_questions?.find((i: any) => i.quote_question_id == item.id);
				if (_item) {
					item.enabled = !!_item.enabled;
					item.quantity = _item.quantity;
					item.description = _item.description;
				}
				return item;
			}),
			services: res.services
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		let index = this.state.quote_amounts.findIndex((i: any) => i.quantity == null || i.quantity == '');

		if (index != -1) {
			const item: any = this.state.quote_amounts[index];
			Globals.showError("Debe ingresar el campo " + item?.name.replace('<strong>','').replace('</strong>',''));
			return;
		}
		
		index = this.state.quote_questions.findIndex((i: any) => i.enabled && ((!i.quantity && i.quantity_name) || (i.description_name && !i.description)));

		if (index != -1) {
			const item: any = this.state.quote_questions[index];
			Globals.showError("Debe ingresar el campo " + item?.name);
			return;
		}

		if (this.props.item != null) {
			await QuoteService.doctor.update({
				quote_id: this.props.item?.id,
				...this.state.form,
				quote_questions: JSON.stringify(this.state.quote_questions),
				quote_amounts: JSON.stringify(this.state.quote_amounts)
			});
			Globals.showSuccess("Se ha modificado la cotización correctamente");
			this.props.onClose();
		}
		else {
			await QuoteService.doctor.create({
				...this.state.form,
				user_id: this.props.user?.id,
				quote_questions: JSON.stringify(this.state.quote_questions),
				quote_amounts: JSON.stringify(this.state.quote_amounts)
			});
			Globals.showSuccess("Se ha modificado la cotización correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-doctor-create-quote">
				<form onSubmit={ this.submit }>
					<div className="col-12">
						<h2>Cotización de cirugía</h2>
						<div className="row">
							<div className="col-md-6">
								<Input
									value={ this.state.form.patient }
									name="patient"
									label="Nombre del paciente"
									onChange={ (e: any) => {
										this.change(e); 
									} } />
							</div>
							<div className="col-md-6">
								<Select
									label="Tipo de Servicio"
									name="service_id"
									onChange={ this.change }
									value={ this.state.form.service_id }
									options={ this.state.services.map((i: any) => {
										return {
											value: i.id,
											label: i.name
										}
									}) } />
							</div>
						</div>
						<div className="container-gray row">
							{
								this.state.quote_amounts.map((item: any, index: number) => {
									return (
										<div className="col-md-3">
											<Input
												type="number"
												value={ item.quantity }
												name="value"
												label={ ReactHtmlParser(item?.name) }
												onChange={ (e: any) => {
													let quote_amounts: any = [...this.state.quote_amounts];
													quote_amounts[index].quantity = e.target.value;
													this.setState({
														quote_amounts
													});
												} } />
										</div>
									)
								})
							}
						</div>
					</div>
					<div className="col-12">
						{
							this.state.quote_questions.map((item: any, index: number) => {
								return (
									<div className="item-question">
										<h3>{ item.name }</h3>
										<div className="row">
											<div className="col-md-6">
												<div className="container-check">
													<div className="item-check" onClick={ () => {
														let quote_questions: any = [...this.state.quote_questions];
														quote_questions[index].enabled = true;
														this.setState({
															quote_questions
														});
													} }>
														<div className={ `circle-check ${ item.enabled ? 'active' : '' }` }>
															{
																item.enabled && (
																	<div className="circle-blue"></div>
																)
															}
														</div>
														Si
													</div>
													<div className="item-check" onClick={ () => {
														let quote_questions: any = [...this.state.quote_questions];
														quote_questions[index].enabled = false;
														quote_questions[index].quantity = '';
														quote_questions[index].description = '';
														this.setState({
															quote_questions
														});
													} }>
														<div className={ `circle-check ${ !item.enabled ? 'active' : '' }` }>
															{
																!item.enabled && (
																	<div className="circle-blue"></div>
																)
															}
														</div>
														No
													</div>
												</div>
											</div>
											<div className="col-md-6">
												{
													item.quantity_name && (
														<Input
															value={ item.quantity }
															name="value"
															disabled={ !item.enabled }
															label={ item.quantity_name }
															onChange={ (e: any) => {
																let quote_questions: any = [...this.state.quote_questions];
																quote_questions[index].quantity = e.target.value;
																this.setState({
																	quote_questions
																});
															} } />
													)
												}

												{
													item.description_name && (
														<Textarea
															rows={ 3 }
															disabled={ !item.enabled }
															value={ item.description }
															name="value"
															label={ item.description_name }
															onChange={ (e: any) => {
																let quote_questions: any = [...this.state.quote_questions];
																quote_questions[index].description = e.target.value;
																this.setState({
																	quote_questions
																});
															} } />
													)
												}
											</div>
										</div>
									</div>
								)
							})
						}
					</div>
					<div className="row row-buttons">
						<div className="col-md-6 text-center">
							<Button type="button" className="btn-close" onClick={ () => this.props.onClose() }>
								Cerrar
							</Button>
						</div>
						<div className="col-md-6 text-center">
							<Button type="submit" className="btn-submit">
								Enviar
							</Button>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalCreate);